import { render, staticRenderFns } from "./editShare.vue?vue&type=template&id=0f09934f&scoped=true"
import script from "./editShare.vue?vue&type=script&lang=js"
export * from "./editShare.vue?vue&type=script&lang=js"
import style0 from "./editShare.vue?vue&type=style&index=0&id=0f09934f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09934f",
  null
  
)

export default component.exports